import styled from 'styled-components';
export const StyledPageWrapper = styled.div.withConfig({ displayName: "StyledPageWrapper", componentId: "sc-gmmmbf" }) `
  flex: 1;
`;
